(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("reportExportUtil", reportExportUtilService);

  /** @ngInject */
  function reportExportUtilService(localeFilters, $translate, $filter) {
    this.getJsonArrayForExport = function (
      groupValueLabel,
      jsonGroupedData,
      groupValueFormatterEnum,
      valueFormatterEnum,
      nameReportConstant
    ) {
      var that = this,
        result = [];

      if (!jsonGroupedData) {
        return result;
      }

      if (!groupValueFormatterEnum) {
        groupValueFormatterEnum = this.ValueFormattersEnum.DEFAULT;
      }

      if (!valueFormatterEnum) {
        valueFormatterEnum = this.ValueFormattersEnum.DEFAULT;
      }

      if (jsonGroupedData.groupsData) {
        Array.from(jsonGroupedData.groupsData).forEach(function (
          groupDataItem
        ) {
          var newItem = {};

          newItem[groupValueLabel] = that.ValueFormattersEnum.properties[
            groupValueFormatterEnum
          ].format(groupDataItem.groupValue);

          Array.from(
            that.filterWhiteSpaceNames(jsonGroupedData.groupNames)
          ).forEach(function (groupName, index) {
            newItem[
              $translate.instant(groupName) +
                " ( " +
                jsonGroupedData.unit +
                " )"
            ] = that.ValueFormattersEnum.properties[valueFormatterEnum].format(
              groupDataItem.values[index]
            );
          });

          this.push(newItem);
        },
        result);
      } else {
        jsonGroupedData.forEach(function (groupDataItem) {
          var newItem = {};

          newItem[groupValueLabel] = that.ValueFormattersEnum.properties[
            groupValueFormatterEnum
          ].format(groupDataItem.date);

          newItem[
            $translate.instant(nameReportConstant) +
              " ( " +
              $translate.instant("LOCAL_TOKEN") +
              " )"
          ] = that.ValueFormattersEnum.properties[valueFormatterEnum].format(
            groupDataItem.count
          );

          this.push(newItem);
        }, result);
      }

      return result;
    };

    this.filterWhiteSpaceNames = function (array) {
      return array.map(function (item) {
        return $filter("removews")(item);
      });
    };

    this.ValueFormattersEnum = Object.freeze({
      CURRENCY: "CURRENCY",
      DATE: "DATE",
      NUMBER: "NUMBER",
      DEFAULT: "DEFAULT",
      DAY: "DAY",
      MONTH: "MONTH",
      properties: {
        CURRENCY: {
          format: function (value) {
            return localeFilters.currency(value, "", 2);
          }
        },
        DATE: {
          format: function (value) {
            return localeFilters.hourly(value);
          }
        },
        NUMBER: {
          format: function (value) {
            return localeFilters.number(value, 2);
          }
        },
        DEFAULT: {
          format: function (value) {
            return value;
          }
        },
        DAY: {
          format: function (value) {
            return localeFilters.getDayLocale(value);
          }
        },
        MONTH: {
          format: function (value) {
            return localeFilters.getMonthLocale(value);
          }
        }
      }
    });
  }
})();
